import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { usePortalAuth } from "@/context/PortalAuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, checking } = usePortalAuth();
  const location = useLocation();

  if (checking) {
    return (
      <div className="min-h-screen bg-[#020617] flex items-center justify-center" data-testid="portal-loading">
        <Loader2 className="animate-spin text-[#D4AF37]" size={28} />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/portal/login" state={{ from: location.pathname + location.search }} replace />;
  }
  return children;
};

export default ProtectedRoute;
